import { View, Text, StyleSheet, TouchableWithoutFeedback } from "react-native";

// Data
import { useDispatch } from "react-redux";
import { setBottomSheet } from "../../../redux/mainSlice";
import { Insight } from "../../../types/data";

// Styles
import { Colors, Typography } from "../../../styles";

const Header = ({ insight }: { insight: Insight }) => {
  const dispatch = useDispatch();

  return (
    <View style={styles.header}>
      <Text style={[Typography.cardTitle, styles.title]}>{insight.title}</Text>
      {/* TODO: add back dots button for tracked card */}
      {/* <TouchableWithoutFeedback
        onPress={() => dispatch(setBottomSheet("watchedCard"))}
      >
        <View style={styles.dots}>
          <View style={styles.dot} />
          <View style={styles.dot} />
          <View style={styles.dot} />
        </View>
      </TouchableWithoutFeedback> */}
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
  },
  title: { flex: 1 },
  dots: {
    padding: 20,
    marginRight: -20,
    marginTop: -20,
    right: 0,
  },
  dot: {
    width: 2.5,
    height: 2.5,
    borderRadius: 2.5 / 2,
    backgroundColor: Colors.plum300,
    marginBottom: 2.5,
  },
});

export default Header;
